<template>
    <div class="content">
        <main>
            <section>
            <h2>Anfahrt</h2>
            <h3>Wegbeschreibung:</h3>

            <h4>Von Wien</h4>
            <p><strong>Mit dem Auto</strong>: A2 - Autobahnabfahrt Pinggau-Friedberg - Wechselbundesstrasse Nr.54, bis Rohrbach/Lafnitz, dann laut Beschilderung nach Mönichwald</p>
            <p><strong>Mit der ÖBB</strong>: Vom Hauptbahnhof bis Rohrbach/Vorau, danach holen wir Sie gerne vom Bahnhof ab.</p>

            <h4>Von Graz</h4>
            <p><strong>Mit dem Auto</strong>: A2 - Autobahnabfahrt Hartberg - Wechselbundesstrasse Nr.54 bis Rohrbach/Lafnitz, dann laut Beschilderung nach Mönichwald</p>
            </section>

            <section>
                <iframe class="gmap" src="https://www.google.com/maps/d/embed?mid=1huvM5dL_itm3gMhonnDi8HA7Jlc"></iframe>
            </section>
        </main>

        <aside>
            <section>
                <h2><a href="https://goo.gl/maps/HLP7GXocfe42" title="Google Maps" target="_blank"><img src="@/assets/pin.svg" width="15px"></a> Adresse</h2>
                <p>Karnerviertel 128<br>8252 Mönichwald</p>
            </section>
            <section>
                <h2>Abholdienst von Wien</h2>
                <p>Wir bieten einen Gästeabholdienst an ({{pickUp}}). Ein Sammeltaxi holt Sie samstags direkt von Ihrem Zuhause ab und bringt Sie zu uns. Auch die Retourfahrten finden an Samstagen statt.</p>
            </section>
            <section>
                <h2>Mönichwald</h2>
                <p>Mönichwald liegt am Südhang des Hochwechsels an der steirischen Blumenstraße
                    im Joglland. Die waldreiche Gegend bietet viele Ausflugs- und Wandermöglichkeiten.</p>
            </section>
        </aside>
    </div>
</template>

<script>
    import { getPickUp }  from "../services/priceService";

    export default {
        name: "Anfahrt",
        computed: {
            pickUp() { return getPickUp() }
        }
    }
</script>

<style lang="scss" scoped>
iframe.gmap {
    width: 100%;
    height: 600px;
    border: 0;
}

    .mobile iframe.gmap {
        display: none;
    }
</style>